<template>
  <div class="main">

    <v-layout row justify-center align-center>
      <v-toolbar color="transparent" flat>

        <v-toolbar-side-icon class="hidden-md-and-up">
          <v-menu bottom right slide-x-transition>
            <v-icon slot="activator">menu</v-icon>
            <v-list class="mobiledropmenu ma-0 pa-0">
              <!-- <v-list-tile class="pt-2"><v-img :src="require(`../img/${logomobile}`)" :height="mobilelogoheight" :width="mobilelogowidth"></v-img></v-list-tile> -->
              <v-list-tile class="pt-3"><span class="tklogo">T K</span><v-img :src="require(`../img/${logomobile}`)" :height="logoheight" :width="logowidth"></v-img></v-list-tile>
              <div v-for="(dropmenuitem, i) in dropmenuitems" :key="i">
                <v-list-tile v-if="dropmenuitem.href">
                  <v-icon :color="dropmenuitem.iconcolor">{{dropmenuitem.icon}}</v-icon>
                  <v-btn
                    class="pl-2 ma-0"
                    round
                    flat
                    active-class
                    :href="dropmenuitem.linkroute"
                    target="_blank"
                    v-text="dropmenuitem.title"
                  >
                  </v-btn>
                </v-list-tile>
                <v-list-tile v-else>
                  <v-icon :color="dropmenuitem.iconcolor">{{dropmenuitem.icon}}</v-icon>
                  <v-btn
                    class="pl-2 ma-0"
                    round
                    flat
                    active-class
                    :to="{ name: `${dropmenuitem.linkroute}`}"
                    v-text="dropmenuitem.title"
                   >
                   </v-btn>
                </v-list-tile>
              </div>
            </v-list>
          </v-menu>
        </v-toolbar-side-icon>

        <v-toolbar-title class="tklogo" v-text="logo"></v-toolbar-title>
        <!-- Using .png for logos -->

        <!-- <v-img class="tklogo hidden-sm-and-down" :src="require(`../img/${logo}`)"></v-img> -->
        <!--
        <div class="tklogo hidden-sm-and-down">
        <v-img :src="require(`../img/${logo}`)" :height="logoheight" :width="logowidth"></v-img>
        </div>
        -->
        <v-spacer></v-spacer>
          <v-toolbar-items class="hidden-sm-and-down menuitems">
            <v-btn flat round class="dropmenu" href="https://www.tkwebdev23.com" target="_blank">TKwebdev23</v-btn>
            <v-btn flat round class="dropmenu" href="https://docs.tkwebdev23.com" target="_blank">Docs.TKwebdev23</v-btn>
            <v-btn flat round class="dropmenu" :to="{ name: 'TkTechnical' }">Technical</v-btn>
            <v-btn flat round class="dropmenu" :to="{ name: 'TkContacts'  }">Contacts</v-btn>
            <v-btn flat round class="dropmenu" :to="{ name: 'TkAboutView' }">About</v-btn>
            <v-btn flat round class="dropmenu" href="https://www.facebook.com/timmyskittys1" target="_blank"><v-icon>fab fa-facebook-square</v-icon></v-btn>
        </v-toolbar-items>
      </v-toolbar>
    </v-layout>

    <v-layout column wrap align-center>
      <v-flex xs12 class="mainlogo">
        <router-link to="/tkbios" class="rtlnk" v-text="mainlogo"></router-link>
      </v-flex>
      <span class="whatisthissite pb-3 pl-5">Also, a couple dogs, horses, raccoons, and others ... </span>
      <!-- <v-btn color="blue darken-1" class="enter-site" to="/tkbios"><v-icon x-large light>fa fa-angle-double-down</v-icon></v-btn> -->
      <!-- <v-btn color="blue darken-1" class="enter-site" to="/tkbios"><v-icon large>fas fa-cat</v-icon></v-btn> -->
      <v-btn color="blue darken-1" class="enter-site" to="/tkbios"><v-icon large>fa fa-paw</v-icon></v-btn>
    </v-layout>

  </div>
</template>

<script>
/* eslint-disable */
import TkBioListView from "./TkBioListView";

export default {
  components: {
    TkBioListView,
  },
  data: () => ({
    logoheight: "140px",
    logowidth: "120px",
    mobilelogoheight: "100px",
    mobilelogowidth: "360px",
    mainlogo: "Timmy's Kitty's",
    logo: "T K",
    // logo: "circle_with_tk_in_middle1.png",
    // logo: "sebastian_logo_blackfilled_blueeyes.png",
    // logo: "sebastian_logo_whitefilled_blueeyes.png",
    // logomobile: "circle_with_tk_in_middle1.png",
    logomobile: "sebastian_logo_layer_at_1440x1105.png",
    dropmenuitems: [
      {
        title: "TKwebdev23",
        linkroute: "https://www.tkwebdev23.com",
        href: true,
        icon: 'fa fa-arrows-alt',
        iconcolor: 'blue darken-1'
      },
      {
        title: "Docs.TKwebdev23",
        linkroute: "https://docs.tkwebdev23.com",
        href: true,
        icon: 'fa fa-book',
        iconcolor: 'blue darken-1'
      },
      {
        title: "Technical",
        linkroute: "TkTechnical",
        href: false,
        icon: 'fa fa-desktop',
        iconcolor: 'blue darken-1'
      },
      {
        title: "Contacts",
        linkroute: "TkContacts",
        href: false,
        icon: 'fa fa-address-book',
        iconcolor: 'blue darken-1'
      },
      {
        title: "About",
        linkroute: "TkAboutView",
        href: false,
        icon: 'fas fa-cat',
        iconcolor: 'blue darken-1'
      },
      {
        title: "TK FaceBook",
        linkroute: "https://www.facebook.com/timmyskittys1",
        href: true,
        icon: 'fab fa-facebook-square',
        iconcolor: 'blue darken-1'
      },
    ],
  }),
};
</script>

<style scoped>
.main {
  background-image: url("../img/background_sebastian_final_1920x1200_cat920x600_opacity85.jpg");
  background-size: cover;
  background-repeat: no-repeat;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  color: #1d2731;
}
.mainlogo {
  font-family: "Great Vibes", Arial, Helvetica, sans-serif;
  font-size: 10rem;
  margin-top: 250px;
}
.whatisthissite {
  font-size: 1.6rem;
  /* font-family: cursive, Arial, Helvetica, sans-serif; */
  font-family: Arial, Helvetica, sans-serif;
}
.searchtk {
  width: 400px;
  position: fixed;
  top: 30%;
  left: 50%;
  margin-left: -250px;
}
.rtlnk {
  list-style-type: none;
  text-decoration: none;
  color: #000;
}
.tklogo {
  font-family: "Great Vibes", Arial, Helvetica, sans-serif;
  font-size: 2.5rem;
  /* margin-top: 50px; */
  /* margin-left: 0; */
 }
.dropmenu {
  font-weight: bold;
  font-size: 1.2rem;
  /* color: #008aff; */
  color: #000;
}
.mobiledropmenu {
  background-color: rgba(255, 255, 255, .6);
  font-weight: bold;
  border-radius: 8px;
}
.enter-site {
  font-family: Helvetica, sans-serif;
  /* margin-top: 100px; */
}
.menuitems {
  color: #000;
}
@media screen and (min-width: 1367px) {
  .mainlogo {
    font-size: 15rem;
    margin-top: 380px;
  }
}
@media screen and (max-width: 1024px) {
  .mainlogo {
    font-size: 6rem;
    margin-top: 280px;
  }
}
/******************** Fire Tabletes and Nexus ****************/
@media only screen and (min-device-width: 600px) and (max-device-width: 960px) and (orientation: portrait) {
  .main {
    background-image: url("../img/background_sebastian_final_768x1024_cat620x476_opacity85.jpg");
  }
  .whatisthissite {
    font-size: 1.4rem;
  }
}
@media only screen and (min-device-width: 600px) and (max-device-width: 960px) and (orientation: landscape) {
 .whatisthissite {
    font-size: 1.2rem;
  }
}

/************************************************ iPads ************************************************/
/******** iPads (portrait) *********/
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
  .main {
    background-image: url("../img/background_sebastian_final_768x1024_cat620x476_opacity85.jpg");
  }
  .mainlogo {
    font-size: 7.5rem;
    margin-top: 320px;
  }
}
/********** iPad 3 (landscape) **********/
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: landscape) and (-webkit-min-device-pixel-ratio: 2) {
  .main {
    background-image: url("../img/background_sebastian_final_ipad_landscape_1024x768_cat620x476_op85.jpg");
  }
  .mainlogo {
    font-size: 6.5rem;
    margin-top: 320px;
  }
}
/************ iPad Pro (portrait) ***********/
@media only screen and (min-device-width: 1024px) and (max-device-width: 1366px) and (orientation: portrait) and (-webkit-min-device-pixel-ratio: 2) {
  .main {
    background-image: url("../img/background_sebastian_final_768x1024_cat620x476_opacity85.jpg");
  }
  .mainlogo {
    font-size: 10rem;
    margin-top: 440px;
  }
}
/************ iPad Pro (landscape) ***********/
@media only screen and (min-device-width: 1024px) and (max-device-width: 1366px) and (orientation: landscape) and (-webkit-min-device-pixel-ratio: 2) {
  .main {
    background-image: url("../img/background_sebastian_final_ipad_landscape_1024x768_cat620x476_op85.jpg");
  }
  .mainlogo {
    font-size: 10rem;
    margin-top: 320px;
  }
}

/************************************** iPhones *************************************/
/* iPhone 6, 7, 8 ----------- */
@media only screen and (min-device-width: 375px) and (max-device-height: 667px) and (orientation: landscape) and (-webkit-device-pixel-ratio: 2) {
  .mainlogo {
    font-size: 5.5rem;
    margin-top: 100px;
  }
  .whatisthissite {
    font-size: 1rem;
  }
}
@media only screen and (min-device-width: 375px) and (max-device-height: 667px) and (orientation: portrait) and (-webkit-device-pixel-ratio: 2) {
  .main {
    background-image: url("../img/background_sebastian_final_iphone_415x745.jpg");
  }
  .mainlogo {
    font-size: 3.5rem;
    margin-top: 180px;
  }
}
/* iPhone 6+, 7+, 8+ ----------- */
@media only screen and (min-device-width: 414px) and (max-device-height: 736px) and (orientation: landscape) and (-webkit-device-pixel-ratio: 2) {
  /* Styles */
}
@media only screen and (min-device-width: 414px) and (max-device-height: 736px) and (orientation: portrait) and (-webkit-device-pixel-ratio: 2) {
  .main {
   background-image: url("../img/background_sebastian_final_iphone_415x745.jpg");
  }
  .mainlogo {
    font-size: 3.5rem;
    margin-top: 180px;
  }
}
/* iPhone X ----------- */
@media only screen and (min-device-width: 375px) and (max-device-height: 812px) and (orientation: landscape) and (-webkit-device-pixel-ratio: 3) {
  .mainlogo {
    font-size: 5.5rem;
    margin-top: 160px;
  }
}
@media only screen and (min-device-width: 375px) and (max-device-height: 812px) and (orientation: portrait) and (-webkit-device-pixel-ratio: 3) {
  .main {
   background-image: url("../img/background_sebastian_final_iphone_415x745.jpg");
  }
  .mainlogo {
    font-size: 3.5rem;
    margin-top: 220px;
  }
}
/* iPhone XS Max, XR ----------- */
@media only screen and (min-device-width: 414px) and (max-device-height: 896px) and (orientation: landscape) and (-webkit-device-pixel-ratio: 3) {
  /* Styles */
}
@media only screen and (min-device-width: 414px) and (max-device-height: 896px) and (orientation: portrait) and (-webkit-device-pixel-ratio: 3) {
  .main {
    background-image: url("../img/background_sebastian_final_iphone_415x745.jpg");
  }
  .mainlogo {
    font-size: 4rem;
    margin-top: 200px;
  }
}

/**************************************** Samsung Galaxy *********************************/
/* Samsung Galaxy S3 ----------- */
@media only screen and (min-device-width: 320px) and (max-device-height: 640px) and (orientation: landscape) and (-webkit-device-pixel-ratio: 2) {
  /* Styles */
}
@media only screen and (min-device-width: 320px) and (max-device-height: 640px) and (orientation: portrait) and (-webkit-device-pixel-ratio: 2) {
  .main {
    background-image: url("../img/background_sebastian_final_iphone_415x745.jpg");
  }
  .mainlogo {
    font-size: 3.3rem;
    margin-top: 170px;
  }
}
/* Samsung Galaxy S4 ----------- */
@media only screen and (min-device-width: 320px) and (max-device-height: 640px) and (orientation: landscape) and (-webkit-device-pixel-ratio: 3) {
  /* Styles */
}
@media only screen and (min-device-width: 320px) and (max-device-height: 640px) and (orientation: portrait) and (-webkit-device-pixel-ratio: 3) {
  .main {
    background-image: url("../img/background_sebastian_final_iphone_415x745.jpg");
  }
  .mainlogo {
    font-size: 3.3rem;
    margin-top: 170px;
  }
}
/* Samsung Galaxy S5 ----------- */
@media only screen and (min-device-width: 360px) and (max-device-height: 640px) and (orientation: landscape) and (-webkit-device-pixel-ratio: 3) {
  /* Styles */
}
@media only screen and (min-device-width: 360px) and (max-device-height: 640px) and (orientation: portrait) and (-webkit-device-pixel-ratio: 3) {
  .main {
    background-image: url("../img/background_sebastian_final_iphone_415x745.jpg");
  }
  .mainlogo {
    font-size: 3.3rem;
    margin-top: 170px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MainView.vue